import React, { useEffect } from 'react';
import { getAuthToken, setAuthToken } from '../utils/local-storage';
import api from '../utils/api';
import { GetSsoCallbackResponse } from '../api/callback/get-sso-callback-response';
import Spinner from '../components/Spinner';
import UnauthorisedView from '../pages/UnauthorisedView';

const AuthHandler: React.FC = ({ children }) => {
  const authToken = getAuthToken();
  const getCodeFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('code');
  };
  const authCode = getCodeFromURL();

  useEffect(() => {
    if (authCode) {
      const getSSOCallback = async () => {
        try {
          const response = await api.get<GetSsoCallbackResponse>('/gateway/v1/sso/callback', {
            params: {
              code: authCode,
              redirect_uri: process.env.REACT_APP_OAUTH_REDIRECT_URI,
            },
          });
          const { idToken } = response.data;
          setAuthToken(idToken);
        } catch (e: any) {
          // Handle error silently or implement proper error handling
        }
        finally {
          if (typeof window !== 'undefined') {
            window.location.href = '/';
          }
        }
      };
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getSSOCallback();
    }
  }, []);

  if (authCode) {
    return <Spinner />;
  }

  if (!authToken) {
    return <UnauthorisedView />;
  }

  return <div>{children}</div>;
};

export default AuthHandler;